
import { handleResponse, requestOptions } from '@/auth';

import * as CONFIG from '@/config/config'

export const myoidService = {
    GetAllMYOIDs,
    setMyoidonload,
    setMyoidloadedfail,
    setMyoidloadedok,
    GetMYOIDforuser,
    CleanLoadStart,
    GetLoadTries,
    GetMeasuresByUserbyMonth,
    SetMyoidNotLoaded,
    SetMyoidNotMeasruedByStudyDoc,
    GetCSV
};

async function setMyoidonload(id) {
    return fetch(CONFIG.CORE_URL + `/myoid/SetMyoidLoad/${id}`, requestOptions.get(id))
       .then(handleResponse);
}

async function setMyoidloadedok(id) {
    return fetch(CONFIG.CORE_URL + `/myoid/SetMyoidLoadedok/${id}`, requestOptions.get(id))
       .then(handleResponse);
}

async function setMyoidloadedfail(id) {
    return fetch(CONFIG.CORE_URL + `/myoid/SetMyoidLoadedfail/${id}`, requestOptions.get(id))
       .then(handleResponse);
}

async function GetAllMYOIDs() {
   return await fetch(CONFIG.CORE_URL + `/myoid/GetAllMYOIDs`, requestOptions.get())
     .then(handleResponse);
}

function GetMYOIDforuser(id) {
    return fetch(CONFIG.CORE_URL + `/myoid/GetMYOIDforuser/${id}`, requestOptions.get(id))
      .then(handleResponse);
 }

async function CleanLoadStart() {
    return fetch(CONFIG.CORE_URL + `/myoid/CleanLoadStart`, requestOptions.get(""))
      .then(handleResponse);
 }

 async function GetLoadTries() {
  return await fetch(CONFIG.CORE_URL + `/myoid/statistics/getloadtries`, requestOptions.get())
  .then(handleResponse);
 }

async function GetMeasuresByUserbyMonth(id) {
  return await fetch(CONFIG.CORE_URL + `/myoid/statistics/byuserbymonth/${id}`, requestOptions.get(id))
  .then(handleResponse);
 }

async function SetMyoidNotLoaded(id) {
  return fetch(CONFIG.CORE_URL + `/myoid/setmyoidnotloaded/${id}`, requestOptions.get(id))
     .then(handleResponse);
}

async function SetMyoidNotMeasruedByStudyDoc(id, messdurchgang) {
  return fetch(CONFIG.CORE_URL + `/myoid/SetMyoidNotMeasruedByStudyDoc/myoid=${id}&messdurchgang=${messdurchgang}`, requestOptions.get())
     .then(handleResponse);
}

async function GetCSV(id) {
  return fetch(CONFIG.CORE_URL + `/myoid/downloadCSV/`, requestOptions.get(id))
    .then(handleResponse);
}